import * as React from 'react';
import {CONTACT_TAB} from '../../../Config/appConfig';
import Invitation from '../Invitation/Invitation';

class NormalUserController extends React.Component {
    public render() {
        return (<Invitation currentTab={CONTACT_TAB.NORMAL_USER}/>);
    }
}

export default NormalUserController;



// WEBPACK FOOTER //
// ./src/Components/Contact/ContactController/NormalUserController.tsx